import { Routes, Route } from "react-router-dom";
import Login from './components/Login'
import Home from "./components/Lists";
import Users from "./components/private/Users";
import Dashboard from "./components/private/Dashboard";
import ProtectedRoutes from "./components/private/ProtectedRoutes";



function App() {
   
  return (
    <Routes basename={process.env.PUBLIC_URL}>
      <Route exact path="/login" element={ <Login /> } />
      <Route element={<ProtectedRoutes />}>
        <Route exact path="/users" element={ <Users />  } />
        <Route exact path="/dashboard" element={ <Dashboard />  } />
      </Route>
      <Route exact path="*" element={ <Home />  } />
    </Routes>
  );
}

export default App;
